export default __webpack_public_path__ + "static/media/Frame.0c13b02a.png";